<template>
	<div
		:class="vFileDownloadClass" class="v-file-download">
		<slot name="downloading">
			<div class="v-file-download__downloading">
				<dl class="v-file__progress">
					<div class="v-file__progress__filename">
						<dt class="sr-only">File</dt>
						<dd>
							<span v-html="filename"/>
							<button
								v-if="requestId" class="button--icon icon--close" @click.prevent="cancel()">Cancel
							</button>
						</dd>
					</div>
					<template v-if="!compact">
						<div>
							<dt class="sr-only">Status</dt>
							<dd class="light">Downloading</dd>
						</div>
						<div class="v-file__progress__progress">
							<dt>Progress</dt>
							<dd>
								<dl>
									<dt>Size</dt>
									<dd v-html="fileSize(progress.downloaded)?.display || '—'"/>
									<dt>Percent</dt>
									<dd v-html="progress.percentDisplay || '—'"/>
								</dl>
							</dd>
						</div>
					</template>
					<div class="v-file__progress__indicator">
						<span class="v-file__progress__indicator__bar">
							<span
								:style="candleStyle"
								class="v-file__progress__indicator__bar__candle">
								<span></span>
							</span>
						</span>
					</div>
				</dl>
			</div>
		</slot>
	</div>
</template>
<script>
import {isNull} from "lodash";
import {mapActions} from "vuex";

export default {
	data() {
		return {
			downloading: false,
			resetTimeout: null,
			percent: 0,
			progress: {
				downloaded: null,
				percent: null,
				percentDisplay: null,
			},
		};
	},

	computed: {
		vFileDownloadClass() {
			return {
				"v-file-download--downloading": this.downloading,
			};
		},
		candleStyle() {
			return {
				width: !this.progress.percent ? 0 : this.progress.percent + "%",
			};
		},
	},

	props: {
		filename: {
			required: true,
			type: String,
		},
		compact: {
			require: false,
			type: Boolean,
			default() {
				return false;
			},
		},
		progressEvent: {
			required: false,
			type: Object,
			default() {
				return null;
			},
		},
		resetDelay: {
			required: false,
			type: Number,
			default() {
				return 3000;
			},
		},
		requestId: {
			required: true,
			type: String,
		},
	},

	watch: {
		progressEvent: {
			deep: true,
			handler: function () {
				this.update();
			},
		},
	},

	methods: {
		...mapActions("downloadsStore", [
			"cancelDownload",
		]),
		isNull,
		update() {
			if (!this.progressEvent) {
				this.progress = Object.assign(this.progress, {
					downloaded: this.progress.downloaded,
					percent: 100,
					percentDisplay: "100%",
				});
				return this.reset(this.resetDelay);
			}
			this.downloading = true;
			this.progress = Object.assign(this.progress, {
				downloaded: this.progressEvent.loaded / 1000,
				percent: this.percent,
				percentDisplay: Math.round(this.percent) + "%",
			});
		},
		reset(delay = null) {
			this.resetTimeout = setTimeout(() => {
				clearTimeout(this.resetTimeout);
				this.downloading = false;
				this.progress = {
					downloaded: null,
					percent: null,
					percentDisplay: null,
				};
				this.resetTimeout = null;
			}, delay || 0);
		},
		fileSize(size) {
			let units = {
				TB: 0.000000001,
				GB: 0.000001,
				MB: 0.001,
				KB: 1,
			};
			let conversions = _.map(units, (value, unit) => {
				value = (size * value).toFixed(2);
				return {
					unit: unit,
					value: value,
					display: value + unit,
				};
			});
			return _.find(conversions, data => {
				return data.value >= 1;
			});
		},
		cancel() {
			http().cancel(this.requestId);
			this.cancelDownload(this.requestId);
		},
	},

	mounted() {
		console.log(`listen for .streamDownload.updated on authed.${this.$authed().id}`);
		window.Echo.private(`authed.${this.$authed().id}`)
			.listen(`.streamDownload.updated.${this.requestId}`, (event) => {
				if (event.percent <= this.percent) {
					return;
				}
				this.percent = event.percent;
			});
	},
};
</script>
